import { z } from "zod";

// eslint-disable-next-line @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match
export const CompanyNameAvailability = z.object({
    available: z.boolean(),
});
